import InterdisciplinaryActivities from './InterdisciplinaryActivities';

export default InterdisciplinaryActivities;
